import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/features/kids/components/KidsShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHead"] */ "/opt/build/repo/src/features/kids/components/ui.tsx");
